import { Icon } from '../components/Icon';
import { useI18n } from './i18n-context';
import { LOCALE_NAMES, LOCALES, isLocale, localeTag } from './locales';

/** Chooses the interface's language, listing each in its own words. */
export function LanguagePicker() {
  const { locale, t, setLocale } = useI18n();
  return (
    <span className="language-picker" title={t.shell.siteLanguage}>
      <Icon name="globe" />
      <span className="language-picker-value" aria-hidden="true">
        {LOCALE_NAMES[locale]}
      </span>
      <span className="language-picker-chevron" aria-hidden="true">
        <Icon name="chevron" />
      </span>
      <select
        className="language-select"
        aria-label={t.shell.siteLanguage}
        value={locale}
        onChange={(event) => {
          if (isLocale(event.target.value)) setLocale(event.target.value);
        }}
      >
        {LOCALES.map((option) => (
          <option key={option} value={option} lang={localeTag(option)}>
            {LOCALE_NAMES[option]}
          </option>
        ))}
      </select>
    </span>
  );
}
